import { IFilterCategoryItem } from './filters.model';
import { SupportedLocales } from './localization.model';
import { IPagination, IPaginationDTO } from './pagination.model';

export enum FeedsEndpoints {
  FEEDS = '/feeds',
}

export enum FeedGenerationStatuses {
  PENDING = 'pending',
  PROCESSING = 'processing',
  FINISHED = 'finished',
  FAILED = 'failed',
}

export interface IRegion {
  id: string;
  name: string;
  locale?: {
    name?: string;
  }[];
}

export interface IFeedStore {
  id: string;
  name: string;
}

export interface IFeed {
  id: string;
  slug: string;
  name: string;
  generation_date: string;
  products_cnt: {
    [SupportedLocales.UK]: number;
    [SupportedLocales.RU]: number;
  };
  files: {
    [SupportedLocales.UK]: string;
    [SupportedLocales.RU]: string;
  };
  active: boolean;
  type: string;
  generation_status: FeedGenerationStatuses;
  regions: IRegion[];
  categories: IFilterCategoryItem[];
  stores?: IFeedStore[];
  min_price?: number | null;
  max_price?: number | null;
  in_stock_only?: boolean;
  exclude_from_general?: boolean;
  all_categories?: boolean;
  locale?: {
    name?: string;
    locale: SupportedLocales;
  }[];
  created_at: string;
  updated_at: string;
}

export interface IOption {
  label: string;
  value: string;
}

// ----------------- DTOs ----------------

export interface IGetFeedsDTO extends Partial<IPaginationDTO> {
  slug?: string;
  name?: string;
  region_ids?: string[];
  category_ids?: string[];
  active?: '1' | '0';
  type?: string;
  generation_type?: 'per_partner' | 'general';
}

export interface IGetFeedDTO {
  id: string;
}

export interface IRegenerateFeedDTO {
  feed_id: string;
}

export interface ICreateFeedDTO {
  slug?: string;
  type?: string;
  region_ids: string[];
  category_ids: string[];
  store_ids?: string[];
  active: '1' | '0';
  min_price?: number | null;
  max_price?: number | null;
  in_stock_only?: boolean;
  exclude_from_general?: boolean;
  all_categories?: boolean;
  locale?: Record<
    string,
    {
      name?: string;
    }
  >;
}

export interface IUpdateFeedDTO extends Partial<ICreateFeedDTO> {
  id: string;
}

export interface IDeleteFeedDTO {
  id: string;
}

export interface IExportFeedDTO {
  feed_id: number;
  locale: SupportedLocales;
}

export interface ICountProductsDTO {
  type: string;
  region_ids: string[];
  category_ids: string[];
  store_ids?: string[];
  min_price?: number | null;
  max_price?: number | null;
  in_stock_only?: boolean;
  all_categories?: boolean;
}

export interface ICountProductsResponse {
  count: number;
}

// ------------ Responses --------------

export interface IGetFeedResponse {
  data: IFeed;
}

export interface IGetFeedsResponse {
  data: IFeed[];
  meta: IPagination;
}
